import { ImsTerrainProvider } from 'app/config/ImsTerrainProvider';
import { AbstractMapLayerProviderList } from 'app/config/AbstractMapLayerProviderList';

export class ImsTerrainProviderList extends AbstractMapLayerProviderList<ImsTerrainProvider> {
    constructor(providers: ImsTerrainProvider[] = []) {
        super(providers);
    }

    clone(): this {
        return new ImsTerrainProviderList(this._providers.map((p) => p.clone())) as any;
    }
}

/**
 * Create from plain old javascript dicts that are received from the API
 *
 * @returns {ImsTerrainProviderList}
 */
export function createTerrainProviderListFromJS(
    terrainProviderJSArray?: any[],
): ImsTerrainProviderList {
    const providers = terrainProviderJSArray?.map((js) => new ImsTerrainProvider(js));
    return new ImsTerrainProviderList(providers);
}
